import GridContainer from "@/components/common/GridContainer"
import { getCssSizeValue, getHtmlFromRedactorField, getPaddingsClassFromData } from "@/utils/utils"
import styled from "styled-components"
import { BREAKPOINTS } from "@/styles/themeSettings"
import HeaderDescriptionBlock from "@/components/HeaderDescriptionBlock"

const StyledContentWrapper = styled.div`
	background: ${(props) => props.theme.colors.antiflashWhite};
	padding: ${getCssSizeValue(16, BREAKPOINTS.MOBILE)};

	@media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
		padding: ${getCssSizeValue(32, BREAKPOINTS.TABLET)};
	}
	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		padding: ${getCssSizeValue(50)};
	}
`

const StyledTableHeader = styled.div`
	margin-bottom: ${getCssSizeValue(30, BREAKPOINTS.MOBILE)};

	@media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
		margin-bottom: ${getCssSizeValue(30, BREAKPOINTS.TABLET)};
	}
	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		margin-bottom: ${getCssSizeValue(20)};
	}
`

const StyledTableWrapper = styled.div`
	overflow-x: auto;
	scrollbar-width: none;

	&::-webkit-scrollbar {
		display: none;
	}

	table {
		width: 100%;
		min-width: ${getCssSizeValue(600, BREAKPOINTS.MOBILE)};
		height: auto;
	}

	table,
	td,
	th {
		border: none !important;
		text-align: left;
		border-bottom: 1px solid ${(props) => props.theme.colors.richBlack} !important;
		padding: 15px 0;
		font-weight: 400 !important;
	}

	em {
		font-style: normal;
		font-weight: 600 !important;
		color: ${(props) => props.theme.colors.pennRed};
	}

	td {
		padding-right: ${getCssSizeValue(10, BREAKPOINTS.MOBILE)};
		overflow-wrap: break-word;
		word-break: break-word;

		&:first-child {
			word-break: initial;
		}
	}

	@media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
		overflow-x: hidden;
		table {
			min-width: unset;
		}

		td {
			word-break: initial;
			overflow-wrap: inital;
			padding-right: ${getCssSizeValue(20, BREAKPOINTS.TABLET)};
		}
	}

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		td {
			padding-right: ${getCssSizeValue(20, BREAKPOINTS.DESKTOP)};
		}
	}
`

export default function TableModule({ data }) {
	const id = data?.id || ""
	const paddings = getPaddingsClassFromData(data)
	const tableHeader = data?.tableHeader || ""
	const tableContent = data?.tableContent || ""
	const columnStart = data?.columnStart?.columnStart || 1

	return (
		<div className={paddings}>
			<HeaderDescriptionBlock headerDescription={data?.headerDescription} />
			<GridContainer id={id} className={`indent-desktop-${columnStart}`}>
				<StyledContentWrapper className="col-desktop-11 col-tablet-8 col-mobile-8 typo-borna">
					<StyledTableHeader dangerouslySetInnerHTML={getHtmlFromRedactorField(tableHeader)} className="typo-borna-29" />
					<StyledTableWrapper>
						<div dangerouslySetInnerHTML={getHtmlFromRedactorField(tableContent)} className="typo-borna-41" />
					</StyledTableWrapper>
				</StyledContentWrapper>
			</GridContainer>
		</div>
	)
}
